<div class="password-component">
  <h4 class="title text-hard-blue">Alterar Senha</h4>
  <form class="full-width" [formGroup]="form" (ngSubmit)="onSubmit()">
    <mat-form-field appearance="outline" class="full-width">
      <input
        matInput
        placeholder="Senha Segura"
        type="password"
        formControlName="password"
      >
      <mat-label>Nova senha</mat-label>
    </mat-form-field>
    <mat-form-field appearance="outline" class="full-width">
      <input
        matInput
        placeholder="Confirmação Senha Segura"
        type="password"
        formControlName="password_confirmation"
      >
      <mat-label>Confirmar nova senha</mat-label>
    </mat-form-field>

    <h5 *ngIf="status == 'E'" style="margin-top: 0;" class="text-red">
      Erro ao trocar a senha
    </h5>
    <h5 *ngIf="status == 'S'" style="margin-top: 0;" class="text-green">
      Senha alterada com sucesso
    </h5>

    <div class="full-width">
      <button
        [disabled]="status != 'W' && status != 'E'"
        mat-raised-button
        color="primary"
        type="submit"
        class="full-width"
      >
        Salvar Nova Senha
      </button>
    </div>
  </form>
</div>
